import { Breadcrumbs } from "@blueprintjs/core"
import { Link } from "@src/Components/Link"
import { Section } from "@src/Components/StyledUtils"
import { colors } from "@src/theme"
import styled from "styled-components"

export const NoteSection = styled(Section)`
  border: 1px solid ${colors.red};
  display: flex;
  align-items: center;
  padding: 12px 20px;
  width: 100%;
  margin-top: 20px;
  border-radius: 6px;

  @media (min-width: 1100px) {
    margin-top: 28px;
  }
`

export const StyledBreadcrumbs = styled(Breadcrumbs)`
  font-family: proxima-nova, sans-serif;
  flex-wrap: wrap;
`

export const StatusText = styled.div`
  cursor: help;
  border-bottom: 1px dashed;
`

export const StyledLink = styled(Link)`
  text-decoration: "underline";
`

export const LastUpdatedText = styled.span`
  line-height: 30px;
  font-size: 16px;
  font-style: italic;
`
